<section class="product-usage" id="lifeStyle">
  <!-- title -->
  <h3 class="product-usage__title">{{ 'global.life_style' | translate }}</h3>

  <!-- life style content -->
  <div class="product-usage__usage-content">
    <!-- life style title -->
    <h4 class="usage-tile">
      {{ mainLifeStyle?.title | translateData }}
    </h4>
    <!-- life style description -->
    <p class="usage-description">
      {{ mainLifeStyle?.description | translateData }}
    </p>
  </div>

  <div class="product-usage__usage-media">
    <!-- selected life styles -->
    @if (mainLifeStyle?.images || mainLifeStyle?.videos) {
      <div class="usage-main-photo">
        <!-- life styles image -->
        @if (mainLifeStyle?.images) {
          <img
            class="usage-main-photo__img"
            [ngSrc]="
              mainLifeStyle?.images?.[0]?.cropped_url?.toLowerCase() ||
                mainLifeStyle?.images?.[0]?.url | imageSource
            "
            width="1200"
            height="700"
            [alt]="mainLifeStyle?.title" />
        } @else if (mainLifeStyle?.videos) {
          <pwj-video-player
            class="usage-main-photo__img"
            playBtnText=""
            [videoPreviewSrc]="mainLifeStyle?.videos?.[0]?.url | imageSource"
            playBtnSize="small"></pwj-video-player>
        }
      </div>
    }
    <!-- other photo -->
    @if (usageData() && usageData().length > 0) {
      <div class="usage-other-photo">
        <!-- scroll to left button -->
        @if (usageData().length > 4) {
          <div class="usage-other-photo__btn">
            <pwj-button
              variant="primary"
              size="large"
              icon="chevron-left"
              [rotateIconInRtl]="true"
              [fullRounded]="true"
              [noContentButton]="true"
              [iconReversePosition]="true"
              (click)="scrollToLeft()"></pwj-button>
          </div>
        }
        <!-- life styles list -->
        <ul
          class="usage-other-photo__images-list no-scrollbar"
          horizontalScroll
          #itemsSlider>
          @for (lifeStyle of usageData(); track lifeStyle?.title) {
            <li class="images-list-item" (click)="selectSliderImg(lifeStyle)">
              @if (
                lifeStyle?.images?.[0]?.cropped_url?.toLowerCase() ||
                lifeStyle?.images?.[0]?.url
              ) {
                <img
                  class="images-list-item__img"
                  [ngSrc]="
                    lifeStyle?.images?.[0]?.cropped_url?.toLowerCase() ||
                      lifeStyle?.images?.[0]?.url | imageSource
                  "
                  width="200"
                  height="128"
                  [alt]="lifeStyle?.title || ''" />
              } @else if (lifeStyle?.videos) {
                <pwj-simple-video-box
                  class="images-list-item__img"
                  playBtnText=""
                  [videoPreviewSrc]="
                    mainLifeStyle?.videos?.[0]?.url | imageSource
                  "
                  playBtnSize="small"></pwj-simple-video-box>
              } @else {
                <img
                  class="images-list-item__img"
                  ngSrc="assets/images/no-card-image-md.svg"
                  width="200"
                  height="128"
                  [alt]="lifeStyle?.title || ''" />
              }
            </li>
          }
        </ul>
        <!-- scroll to right button -->
        @if (usageData().length > 4) {
          <div class="usage-other-photo__btn">
            <pwj-button
              variant="primary"
              size="large"
              icon="chevron-right"
              [rotateIconInRtl]="true"
              [fullRounded]="true"
              [noContentButton]="true"
              [iconReversePosition]="true"
              (click)="scrollToRight()"></pwj-button>
          </div>
        }
      </div>
    }
  </div>
</section>
